export enum DocumentReviewValidationRuleType {
    MissingRedactedPdf,
    ResponsiveInvalid,
    ResponsiveEmailFamily,
    PrivilegeEmailFamily,
    WorkProductEmailFamily,
    PageCount,
    PartialPrivilegedCoding,
    PartialPrivilegedRedaction
}